import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema, additionalState } from './config';

import AutoCompleteSolo from '../../utils/utilities/AutoCompleteSolo';

import useInputDebounce from '../../hooks/useInputDebounce';

// form context
import { useFormData } from '../../contexts/FormData';

import EditInventoryItem from '../InventoryItem/EditInventory';

import InventoryItem from '../../utils/utilities/WigComponents/InventoryItem';

import RequestItems from './Components/RequestItems';

const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  margin-top: 1.5rem;
`;

const EditRequest = () => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  
  return (
    <EditForm title={"Request"} initialValues={initialValues} additionalState={additionalState} fields={formFields} schema={schema} url={"requests"}>

      {/* <RequestItems /> */}
      
     </EditForm>
  );
}

export default EditRequest;